{
  "plan_details": {
    "frequency": {
      "annually": "Annually",
      "monthly": "Monthly",
      "title": "Pay annually and save 10%"
    },
    "choose_currency": "Choose your currency",
    "includes": "What's included:",
    "everything_in": "Everything in {{ plan }}, plus:",
    "per_user": "per user / per month",
    "switch_to": "Switch to {{ plan }}",
    "upgrade_to": "Upgrade to {{ plan }}",
    "manage_plan": "Manage plan",
    "call_us": "Call us",
    "contact_us": "Contact us",
    "title": {
      "part_1": "Choose the perfect plan for you and your",
      "part_2": "Team"
    },
    "subtitle": {
      "part_1": "Compare our plans and features on our",
      "part_2": "pricing page",
      "part_3": "or"
    },
    "plans": {
      "professional": {
        "name": "professional",
        "prev_plan": "",
        "features": {
          "1": "Unlimited plans for your event",
          "2": "Access to an extensive library of layer templates",
          "3": "3D models to accurately visualise plans",
          "4": "Attributes to capture data including dates and costs",
          "5": "Shared workspace for your team",
          "6": "Customisable and flexible layers and icons",
          "7": "Analysis tools including crowd capacity calculator",
          "8": "Professional PDF exports",
          "9": "CAD integration and unlimited updates",
          "10": "Onboarding support",
          "11": "Unlimited viewers!"
        }
      },
      "premium": {
        "name": "premium",
        "prev_plan": "professional",
        "features": {
          "1": "Capture and visualise plans by time and date",
          "2": "Collaboration tools incl. comments, tagging, threads",
          "3": "Combine plans from different users and teams",
          "4": "Analyse quantities and costs across your project",
          "5": "Geospatial data export in GIS formats",
          "6": "CAD importing service",
          "7": "Bespoke onboarding support",
          "8": "Unlimited viewers!"
        }
      },
      "enterprise": {
        "name": "enterprise",
        "prev_plan": "premium",
        "features": {
          "1": "Bespoke onboarding and account management",
          "2": "Visualise plans using gaming quality graphics",
          "3": "Plan using Google 3D city maps",
          "4": "Publish branded maps online",
          "5": "Expert support to create 3D models, icons and templates",
          "6": "SSO for added security",
          "7": "24/7 support"
        }
      }
    }
  }
}